import { render } from "./yourDataSafe.vue?vue&type=template&id=42d6e864&scoped=true&lang=html"
import script from "./yourDataSafe.vue?vue&type=script&lang=js"
export * from "./yourDataSafe.vue?vue&type=script&lang=js"

import "./yourDataSafe.vue?vue&type=style&index=0&id=42d6e864&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d6e864"]])

export default __exports__